import { CircularProgress } from '@mui/material';
import { memo, useRef } from 'react';
import { useDraggable } from 'react-use-draggable-scroll';
import Shaxmatka2BlockItem from './block/Shaxmatka2BlockItem';
import { DragDropContext } from '@hello-pangea/dnd';
import useAxiosPrivate from 'hooks/useAxiosPrivate';
import useNotification from 'hooks/useNotification';

export default memo(function Shaxmatka1({
  isLoading,
  blocks,
  toggleSelectionItem,
  settingsMenuValue,
  isEditing = false,
  refetch = () => {},
}) {
  const ref = useRef();
  const axiosPrivate = useAxiosPrivate();
  const sendNotification = useNotification();
  const { events } = useDraggable(ref);

  const handleDragEnd = (result) => {
    const { source, destination, draggableId } = result;

    // agar tashlamagan bo‘lsa (masalan, tashqariga)
    if (!destination) return;

    // faqat o‘z ichida ruxsat beramiz
    if (source.droppableId !== destination.droppableId) return;

    const placeId = destination?.index + 1;
    handleDone(draggableId, placeId);
  };

  const handleDone = async (homeid, placeId) => {
    try {
      const response = await axiosPrivate.post(
        `admin/home/updateplace/${homeid}`,
        { placeId },
        {
          headers: { 'Content-Type': 'application/json' },
        }
      );
      if (response.data && response.data.status) {
        sendNotification({
          msg: 'Joy almashtirildi!',
          variant: 'success',
        });
        refetch(true);
      }
    } catch (error) {
      sendNotification({
        msg: error?.response?.data?.message || error?.message,
        variant: 'error',
      });
    }
  };

  return (
    <div className='sheet-wrapper type-2'>
      <DragDropContext onDragEnd={handleDragEnd}>
        <div className='sheet-base-area'>
          <div
            className='sheet-grid gap-2'
            // {...events}
            ref={ref}
          >
            {isLoading ? (
              <div className='circular-progress-box min-h-[500px] h-full w-full'>
                <CircularProgress size={50} />
              </div>
            ) : (
              blocks &&
              blocks?.map(
                (block, index) =>
                  block?.padezd?.length > 0 && (
                    <div
                      className='sheet-column flex gap-0'
                      key={`block-${block?.id}-columns`}
                      id={`block-${block?.id}-columns`}
                    >
                      <Shaxmatka2BlockItem
                        blockItem={block}
                        blockIndex={index}
                        isEditing={isEditing}
                        toggleSelectionItem={toggleSelectionItem}
                        settingsMenuValue={settingsMenuValue}
                      />
                    </div>
                  )
              )
            )}
          </div>
        </div>
      </DragDropContext>
    </div>
  );
});
